import { render, staticRenderFns } from "./RevenueLastMonthCompare.vue?vue&type=template&id=18b66bbc&scoped=true"
import script from "./RevenueLastMonthCompare.vue?vue&type=script&lang=ts"
export * from "./RevenueLastMonthCompare.vue?vue&type=script&lang=ts"
import style0 from "./RevenueLastMonthCompare.vue?vue&type=style&index=0&id=18b66bbc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b66bbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b66bbc')) {
      api.createRecord('18b66bbc', component.options)
    } else {
      api.reload('18b66bbc', component.options)
    }
    module.hot.accept("./RevenueLastMonthCompare.vue?vue&type=template&id=18b66bbc&scoped=true", function () {
      api.rerender('18b66bbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/RevenueLastMonthCompare.vue"
export default component.exports